import React from 'react';
import clsx from 'clsx';
import moment from 'moment';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  TableContainer,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {},
  actions: {
    padding: theme.spacing(0, 1),
    justifyContent: 'flex-end'
  },
  nodata: {
    padding: theme.spacing(2)
  }
}));

const Results = props => {
  const {
    className,
    onPageChange,
    onPageLimit,
    rows,
    totalcount,
    page,
    rowsPerPage,
    ...rest
  } = props;

  const classes = useStyles();

  const handleChangePage = (event, newPage) => {
    onPageChange(event, newPage);
  };

  const handleChangeRowsPerPage = event => {
    onPageLimit(event);
  };

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Card>
        <CardHeader title="Exhibitor stall requests" />
        <Divider />
        <CardContent className={classes.content}>
          <div className={classes.inner}>
            <TableContainer className={classes.container}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>S No</TableCell>
                    <TableCell>Company</TableCell>
                    <TableCell>Contact</TableCell>
                    <TableCell>Mobile</TableCell>
                    <TableCell>Email</TableCell>
                    <TableCell>City</TableCell>
                    <TableCell>Submitted</TableCell>
                    <TableCell>Updated</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(!rows || rows.length === 0) ? (
                    <TableRow>
                      <TableCell colSpan={8}>
                        <Typography className={classes.nodata} component="p" variant="body1">
                          No records found
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ) : (
                    rows.map((row, index) => {
                      const created = row.createdAt;
                      const updated = row.updatedAt;
                      return (
                        <TableRow key={row.id != null ? row.id : index}>
                          <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                          <TableCell>{row.companyname != null ? String(row.companyname) : ''}</TableCell>
                          <TableCell>{row.contactname != null ? String(row.contactname) : ''}</TableCell>
                          <TableCell>{row.mobilenumber != null ? String(row.mobilenumber) : ''}</TableCell>
                          <TableCell>{row.email != null ? String(row.email) : ''}</TableCell>
                          <TableCell>{row.city != null ? String(row.city) : ''}</TableCell>
                          <TableCell>
                            <Typography variant="body2">
                              {created
                                ? moment(created).format('DD MMM YYYY hh:mm a')
                                : ''}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Typography variant="body2">
                              {updated
                                ? moment(updated).format('DD MMM YYYY hh:mm a')
                                : ''}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      );
                    })
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </CardContent>
        <CardActions className={classes.actions}>
          <TablePagination
            component="div"
            count={totalcount || 0}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            page={page}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[5, 10, 20, 25, 50]}
          />
        </CardActions>
      </Card>
    </div>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  rows: PropTypes.array.isRequired,
  totalcount: PropTypes.number,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onPageLimit: PropTypes.func.isRequired
};

Results.defaultProps = {
  rows: [],
  totalcount: 0
};

export default Results;
